import type { ButtonHTMLAttributes } from "react";
import { Icon, type IconName } from "./Icon";

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: "primary" | "secondary" | "quiet" | "danger" | "success";
  size?: "md" | "lg" | "xl";
  icon?: IconName;
  iconEnd?: IconName;
  block?: boolean;
  loading?: boolean;
}

/** Knopf für jede Aktion; `primary` höchstens einmal je Bildschirm. `loading` sperrt und zeigt einen Kreisel. */
export function Button({ variant = "secondary", size = "md", icon, iconEnd, block, loading, className, children, disabled, type = "button", ...rest }: ButtonProps) {
  const iconSize = size === "xl" ? 28 : size === "lg" ? 24 : 20;
  const cls = ["rg-btn", `rg-btn--${variant}`, size !== "md" && `rg-btn--${size}`, block && "rg-btn--block", className].filter(Boolean).join(" ");
  return (
    <button type={type} className={cls} disabled={disabled || loading} aria-busy={loading || undefined} {...rest}>
      {loading ? <span className="rg-spin" aria-hidden="true" /> : icon ? <Icon name={icon} size={iconSize} /> : null}
      {children}
      {iconEnd && !loading ? <Icon name={iconEnd} size={iconSize} /> : null}
    </button>
  );
}

/** Nur-Icon-Knopf (48 px), immer mit `label`. */
export function IconButton({ icon, label, className, ...rest }: { icon: IconName; label: string } & ButtonHTMLAttributes<HTMLButtonElement>) {
  return (
    <button type="button" className={["rg-iconbtn", className].filter(Boolean).join(" ")} aria-label={label} title={label} {...rest}>
      <Icon name={icon} />
    </button>
  );
}
